import { makeStyles } from '@material-ui/core/styles';
import { Box, CircularProgress } from '@material-ui/core';
import Checklabel from './checkbox';

const useStyles = makeStyles((theme) => ({}));

export default function Checknote({ id, tasksList, loading, isHideCompletedItem, type, ...props }) {
  const classes = useStyles();

  return (
    <div className={classes.context}>
      {loading ? (
        <Box width="100%" height="5rem" display="flex" justifyContent="center" alignItems="center" m="1.25rem 0">
          <CircularProgress color="primary" />
        </Box>
      ) : (
        tasksList.filter(item => isHideCompletedItem ? item.IS_COMPLETE !== 'Y' : true).map((item, index) => {
          return <Checklabel id={id + index} key={item.ID} item={item} {...props} />;
        })
      )}
    </div>
  );
}
